/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { NFTGallery } from "../NFTGallery";

export class NFTGallery__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    baseSettings: {
      name: string;
      symbol: string;
      payees: string[];
      shares: BigNumberish[];
      typeOfNFT: BigNumberish;
      maxSupply: BigNumberish;
    },
    overrides?: Overrides
  ): Promise<NFTGallery> {
    return super.deploy(baseSettings, overrides || {}) as Promise<NFTGallery>;
  }
  getDeployTransaction(
    baseSettings: {
      name: string;
      symbol: string;
      payees: string[];
      shares: BigNumberish[];
      typeOfNFT: BigNumberish;
      maxSupply: BigNumberish;
    },
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(baseSettings, overrides || {});
  }
  attach(address: string): NFTGallery {
    return super.attach(address) as NFTGallery;
  }
  connect(signer: Signer): NFTGallery__factory {
    return super.connect(signer) as NFTGallery__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTGallery {
    return new Contract(address, _abi, signerOrProvider) as NFTGallery;
  }
}

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "payees",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "shares",
            type: "uint256[]",
          },
          {
            internalType: "uint32",
            name: "typeOfNFT",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "maxSupply",
            type: "uint32",
          },
        ],
        internalType: "struct BaseSettings",
        name: "baseSettings",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tokenPrice_",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "startTimestamp_",
        type: "uint128",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIdList",
        type: "uint256[]",
      },
    ],
    name: "mintToken",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIdList",
        type: "uint256[]",
      },
    ],
    name: "reserveNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "settings",
    outputs: [
      {
        internalType: "uint32",
        name: "maxSupply",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "totalSupply",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "maxPurchase",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "typeOfNFT",
        type: "uint32",
      },
      {
        internalType: "uint128",
        name: "startTimestamp",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recevier",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "specialMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
